import { publishOtp } from './PublishStore';

export const updatePublishOtp = (value) => publishOtp.update((oldValue) => value);
